import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./AuthProvider";
import HomePage from "./HomePage";
import PhoneGate from "./PhoneGate";

const Bingo10 = lazy(() => import("./games/Bingo10"));
const Bingo20 = lazy(() => import("./games/Bingo20"));
const Emoji5  = lazy(() => import("./games/Bingo30"));
const Emoji10 = lazy(() => import("./games/Bingo40"));
const Keno5  = lazy(() => import("./games/Keno5"));

// Get user data from URL parameters, localStorage, or Telegram WebApp
const getUserData = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlData = {
    username: urlParams.get("username"),
    phone: urlParams.get("phone"),
    balance: urlParams.get("balance"),
    telegram_id: urlParams.get("telegram_id"),
  };

  const hasUrlData = urlData.telegram_id;

  if (hasUrlData) {
    const rawUsername = urlData.username;
    const cleanUsername = (rawUsername && rawUsername !== "None" && rawUsername !== "null") ? rawUsername : "User";
    const rawPhone = urlData.phone;
    const cleanPhone = (rawPhone && rawPhone !== "None" && rawPhone !== "null") ? rawPhone : "Not registered";
    const userData = {
      username: cleanUsername,
      phone: cleanPhone,
      balance: parseFloat(urlData.balance) || 0,
      telegram_id: urlData.telegram_id,
    };
    localStorage.setItem("lala_user", JSON.stringify(userData));
    return userData;
  }

  // Try localStorage (survives reload)
  const stored = localStorage.getItem("lala_user");
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch (e) {
      localStorage.removeItem("lala_user");
    }
  }

  // Try Telegram WebApp (for "Open" button without URL params)
  if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.initDataUnsafe) {
    const tgUser = window.Telegram.WebApp.initDataUnsafe.user;
    if (tgUser && tgUser.id) {
      const userData = {
        username: tgUser.username || tgUser.first_name || "User",
        phone: "Not registered",
        balance: 0,
        telegram_id: String(tgUser.id),
      };
      localStorage.setItem("lala_user", JSON.stringify(userData));
      return userData;
    }
  }

  return {
    username: "User",
    phone: "Not registered",
    balance: 0,
    telegram_id: null,
  };
};

export default function App() {
  const userData = getUserData();

  return (
    <AuthProvider userData={userData}>
      <Router>
        <PhoneGate>
        <Suspense fallback={<div className="page loading-screen">Loading...</div>}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/bingo-10" element={<Bingo10 />} />
            <Route path="/bingo-20" element={<Bingo20 />} />
            <Route path="/emoji-5" element={<Emoji5 />} />
            <Route path="/emoji-10" element={<Emoji10 />} />
            <Route path="/bingo-30" element={<Emoji5 />} />
            <Route path="/bingo-40" element={<Emoji10 />} />
            <Route path="/keno-5" element={<Keno5 />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Suspense>
        </PhoneGate>
      </Router>
    </AuthProvider>
  );
}
